<template>
  <ul class="order-options">
    <li
      v-for="(option, index) in options"
      :key="index"
    >
      <b>{{ option.optionLabel }}</b> {{ option.label }}
    </li>
  </ul>
</template>

<script setup lang="ts">
defineProps({
  options: {
    required: true,
    type: Array<any>,
  },
});
</script>

<style lang="scss">
.order-options {
  padding-left: 16px;
  li {
    word-break: normal;
    white-space: normal;
  }
}
</style>
